import { Box, styled } from '@mui/material'
import { DecisionConfirmationButton } from 'components'
import {
    useAccessRequestPolicy,
    useRequestApprovalDecisions,
    useSubmitRequestDecision,
} from 'hooks'
import React, { useState } from 'react'
import { Skeleton } from '@mui/material'
import { smallScreenWidth } from 'utils'

const RequestApprovalDecisionPromptContainer = styled(Box)({
    flex: '1',
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '15px 30px',
    [`@media (max-width:${smallScreenWidth})`]: {
        flexWrap: 'wrap',
        '& button': {
            marginBottom: '12px',
            minWidth: '260px',
        },
    },
})

export const RequestApprovalDecisionPrompt = ({ businessRequest }: any) => {
    const { data: approvalDecisions, isLoading: isLoadingApprovalDecisions } =
        useRequestApprovalDecisions(
            businessRequest.id,
            businessRequest.isApprovable,
        )
    const [startDate, setStartDate] = useState(businessRequest.startDateUtc)
    const [endDate, setEndDate] = useState(businessRequest.endDateUtc)
    const [timeConstrainedControl, setTimeConstrainedControl] = useState(false)
    const policy = useAccessRequestPolicy(businessRequest?.requestPolicyId)
    const [submitRequestDecision, { isLoading: isSubmittingRequestDecision }] =
        useSubmitRequestDecision(businessRequest.id)

    const [decisionComment, setDecisionComment] = useState('')

    return (
        <RequestApprovalDecisionPromptContainer>
            {isLoadingApprovalDecisions ? (
                <Box marginX="30px">
                    <Skeleton
                        variant="rectangular"
                        animation="wave"
                        width={192}
                        height={40}
                    />
                </Box>
            ) : (
                approvalDecisions &&
                approvalDecisions.map((ad: any) => {
                    return (
                        <Box
                            component="span"
                            key={ad.decisionId}
                            marginX="15px"
                        >
                            <DecisionConfirmationButton
                                approvalDecision={ad}
                                decisionComment={decisionComment}
                                setDecisionComment={setDecisionComment}
                                isLoading={isSubmittingRequestDecision}
                                showTimeConstraintControl={
                                    ad.isTimeConstraintEditable
                                }
                                handleToggleValue={
                                    setTimeConstrainedControl as any
                                }
                                requireTimeControl={ad.isTimeConstraintRequired}
                                startDate={startDate}
                                endDate={endDate}
                                setStartDate={setStartDate}
                                setEndDate={setEndDate}
                                policy={policy}
                                onSuccess={() => {
                                    const reqData: any = {
                                        id: businessRequest.id,
                                        stepId: businessRequest.currentApprovalStepId,
                                        decisionId: ad.decisionId,
                                        requestDataAssignmentStartDate:
                                            timeConstrainedControl
                                                ? startDate
                                                : null,
                                        requestDataAssignmentEndDate:
                                            timeConstrainedControl
                                                ? endDate
                                                : null,
                                    }
                                    if (decisionComment) {
                                        reqData.comment = decisionComment
                                    }
                                    return submitRequestDecision(reqData).then(
                                        () => {
                                            setDecisionComment('')
                                        },
                                    )
                                }}
                            />
                        </Box>
                    )
                })
            )}
        </RequestApprovalDecisionPromptContainer>
    )
}
